import React, { useMemo } from 'react';

import { getColorFromGoalProgressLevel, getGoalProgressMarks, getMatchedTypeFromUnit } from 'services/helpers/goal';

import ProgressSlider from './ProgressSlider';

export default function GoalProgressSlider({
  onChange,
  onChangeCommitted,
  targetValue,
  initialValue,
  unit,
  progressLevel,
  achieved,
  className,
}) {
  const isInverse = initialValue > targetValue;
  function getValueAccordingToInverse(value) {
    return isInverse ? targetValue + initialValue - value : value;
  }
  const { label: unitSymbol, isPrefix } = useMemo(() => getMatchedTypeFromUnit(unit), [unit]);

  return (
    <ProgressSlider
      className={className}
      min={isInverse ? targetValue : initialValue}
      max={isInverse ? initialValue : targetValue}
      step={isInverse ? -1 : 1}
      marks={getGoalProgressMarks({ isInverse, isPrefix, targetValue, initialValue, unitSymbol })}
      color={getColorFromGoalProgressLevel(progressLevel)}
      valueLabelDisplay="off"
      onChange={(_, value) => {
        const newValue = getValueAccordingToInverse(value);
        onChange(newValue);
      }}
      onChangeCommitted={(_, value) => {
        const newValue = getValueAccordingToInverse(value);
        onChangeCommitted(newValue);
      }}
      value={getValueAccordingToInverse(achieved)}
      aria-label="progress slider"
    />
  );
}
